"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var SHOPIFY_API_BASE = 'shopify/v1';
var ECOMMERCE_API_BASE = 'extensions/ecomm/v1';

var EcommerceApi =
/*#__PURE__*/
function () {
  function EcommerceApi() {
    (0, _classCallCheck2.default)(this, EcommerceApi);
  }

  (0, _createClass2.default)(EcommerceApi, null, [{
    key: "getShopifyStatus",
    value: function getShopifyStatus() {
      return _apiClient.default.get(SHOPIFY_API_BASE + "/status");
    }
  }, {
    key: "getShopifyShop",
    value: function getShopifyShop() {
      return _apiClient.default.get(SHOPIFY_API_BASE + "/shop");
    }
  }, {
    key: "getStats",
    value: function getStats() {
      return _apiClient.default.get(ECOMMERCE_API_BASE + "/stats");
    }
  }, {
    key: "disconnectShopify",
    value: function disconnectShopify(storeName) {
      return _apiClient.default.delete(SHOPIFY_API_BASE + "/uninstall/" + storeName);
    }
  }, {
    key: "getIsEcommBridgeIntegrationConnected",
    value: function getIsEcommBridgeIntegrationConnected() {
      return _apiClient.default.get(ECOMMERCE_API_BASE + "/info/is-ecomm-enabled");
    }
  }, {
    key: "getInstalledEcommerceIntegrationIds",
    value: function getInstalledEcommerceIntegrationIds() {
      return _apiClient.default.get(ECOMMERCE_API_BASE + "/info/installed-ecomm-apps");
    }
  }]);
  return EcommerceApi;
}();

exports.default = EcommerceApi;
module.exports = exports.default;